// Event-query domain primitives shared by the backend services and the admin
// filter UI. Pure (no runtime dependencies) so any app can import them — via the
// `.` barrel or the granular `@logspot-platform/platform-types/events` subpath —
// without pulling anything heavy. Previously duplicated in
// `apps/backend/src/services/event-types.ts`, the public-analytics wrapper, and
// `apps/admin` (`filter-dialog-button.tsx` Operator, `types.ts` Filter).
/** SQL comparison operators used by event search / analytics filters. */
export var Operator;
(function (Operator) {
    Operator["EQ"] = "=";
    Operator["GTE"] = ">=";
    Operator["LTE"] = "<=";
    Operator["LT"] = "<";
    Operator["GT"] = ">";
    Operator["NEQ"] = "<>";
    Operator["NULL"] = "IS NULL";
    Operator["NOT_NULL"] = "IS NOT NULL";
})(Operator || (Operator = {}));
/** Dimensions the `/aggregate` analytics endpoint can group by. */
export var AggregateField;
(function (AggregateField) {
    AggregateField["location_country"] = "location_country";
    AggregateField["location_city"] = "location_city";
    AggregateField["location_region"] = "location_region";
    AggregateField["device"] = "device";
    AggregateField["os"] = "os";
    AggregateField["browser"] = "browser";
    AggregateField["screen"] = "screen";
    AggregateField["language"] = "language";
    AggregateField["referrer"] = "referrer";
    AggregateField["url"] = "url";
    // Per-session derivation (first page of the session), so its counts are
    // sessions started, not pageviews.
    AggregateField["entry_url"] = "entry_url";
    AggregateField["hostname"] = "hostname";
    AggregateField["user_id"] = "user_id";
    // Derived at read time from referrer + utm_source/utm_medium, not a column.
    AggregateField["acquisition_channel"] = "acquisition_channel";
})(AggregateField || (AggregateField = {}));
//# sourceMappingURL=events.js.map